import { render, staticRenderFns } from "./informationPrompt.vue?vue&type=template&id=0836d5b8&scoped=true&"
import script from "./informationPrompt.vue?vue&type=script&lang=js&"
export * from "./informationPrompt.vue?vue&type=script&lang=js&"
import style0 from "./informationPrompt.vue?vue&type=style&index=0&id=0836d5b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0836d5b8",
  null
  
)

export default component.exports